import { useMemo } from 'react'
import { Address } from 'types/common'

export function useGoogleMapsLink(fullAddress?: Address) {
  return useMemo(() => {
    if (!fullAddress) return null
    const gmapsUrl = new URL('https://www.google.com/maps')
    const { address, city, state, zip } = fullAddress
    const addressString = [address, city, state, zip].join(' ').split(' ').join('+')
    gmapsUrl.searchParams.set('q', addressString)
    return gmapsUrl.href
  }, [fullAddress])
}
